import { useEffect } from 'react'
// import '../components/pages/home/Home.scss'

export function useSetBodyBackgrounds(bgClass) {
    useEffect(() => {
        document.body.classList.add(bgClass)
        return () => {
            document.body.classList.remove(bgClass)
        }
    }, [bgClass])
}
